import { render } from "./QuoteInterpretation.vue?vue&type=template&id=019c2fe2&scoped=true"
import script from "./QuoteInterpretation.vue?vue&type=script&lang=js"
export * from "./QuoteInterpretation.vue?vue&type=script&lang=js"

import "./QuoteInterpretation.vue?vue&type=style&index=0&id=019c2fe2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-019c2fe2"

export default script